module.exports = __webpack_public_path__ + "static/media/e18.76f27ed8.jpg";